import { types } from './actions';

const initialState = {
  areCustomerFacingNotesFetching: false,
  customerFacingNotes: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_CUSTOMER_FACING_NOTES_ERROR:
      return {
        ...state,
        areCustomerFacingNotesFetching: false,
      };
    case types.FETCH_CUSTOMER_FACING_NOTES_SUCCESS:
      return {
        ...state,
        areCustomerFacingNotesFetching: false,
        customerFacingNotes: payload.customerFacingNotes,
      };
    case types.UPDATE_CUSTOMER_FACING_NOTES_ERROR:
      return {
        ...state,
        areCustomerFacingNotesFetching: false,
      };
    case types.UPDATE_CUSTOMER_FACING_NOTES_REQUEST:
      return {
        ...state,
        areCustomerFacingNotesFetching: true,
      };
    case types.UPDATE_CUSTOMER_FACING_NOTES_SUCCESS:
      return {
        ...state,
        areCustomerFacingNotesFetching: false,
        customerFacingNotes: payload.customerFacingNotes,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.digitalQuote.quoteNotes;

export const areCustomerFacingNotesFetching = (state) =>
  getScope(state).areCustomerFacingNotesFetching;

export const getCustomerFacingNotes = (state) =>
  getScope(state).customerFacingNotes;
